import { useEffect, useState, useMemo } from 'react'
import { DataGrid } from '@material-ui/data-grid'
import { getIndustryInfo } from '../data'
import { Container, LinearProgress } from '@material-ui/core'
import { Helmet } from 'react-helmet-async'

function OreImport() {
    const [data, setData] = useState([])
    const [error, setError] = useState(null)
    const [loaded, setLoaded] = useState(false)

    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: '',
                width: 50,
                renderCell: (params) =>
                    params.row.invalid ? null : (
                        <img
                            src={`https://images.evetech.net/types/${params.value}/icon?size=32`}
                            alt={params.row.name}
                            width={25}
                            height={25}
                        />
                    ),
            },
            {
                field: 'name',
                headerName: 'Ore',
                width: 500,
            },
            {
                field: 'reprocessed_value',
                headerName: 'Reprocessed Value',
                width: 200,
                valueFormatter: (params) => params.value.toLocaleString(),
            },
            {
                field: 'buy_price',
                headerName: 'Buy Price',
                width: 200,
                valueFormatter: (params) => params.value.toLocaleString(),
            },
            {
                field: 'margin',
                headerName: 'Margin',
                width: 200,
                renderCell: (params) =>
                    params.value < 0 ? (
                        <span style={{ color: 'red' }}>{params.value.toLocaleString()}</span>
                    ) : (
                        <span>{params.value.toLocaleString()}</span>
                    ),
            },
            {
                field: 'markup',
                headerName: 'Markup',
                width: 200,
                renderCell: (params) =>
                    params.value < 0 ? (
                        <span style={{ color: 'red' }}>{params.value.toLocaleString()} %</span>
                    ) : (
                        <span>{params.value.toLocaleString()} %</span>
                    ),
            },
        ],
        []
    )

    useEffect(() => {
        const fetchData = () => {
            Promise.all([getIndustryInfo(['import_ore'])])
                .then((results) => {
                    setData(results[0].data)
                    setLoaded(true)
                    setError(null)
                })
                .catch((error) => {
                    setError(error)
                })
        }
        fetchData()
    }, [])

    if (error) {
        return (
            <Container>
                <h3>Error</h3>
                <p>{error.message}</p>
            </Container>
        )
    }

    if (!loaded) return <LinearProgress />

    return (
        <div style={{ width: '100%' }}>
            <Helmet>
                <title>Ore Import</title>
            </Helmet>
            <DataGrid columns={columns} rows={data} rowHeight={25} autoHeight />
        </div>
    )
}

export default OreImport
